<template>
  <JoszakiModal
    :open="isModalOpen"
    :title="$t('questionPage.reportAnswerModal.title')"
    @close="closeModal"
  >
    <template #body>
      <JoszakiLoading :active="isSaving" />
      <p>
        {{ $t("questionPage.reportAnswerModal.info") }}
      </p>
      <JoszakiTextArea
        v-model="answerReportBody"
        :placeholder="$t('questionPage.reportAnswerModal.placeholder')"
      />
    </template>

    <template #footer>
      <div class="flex flex-1 justify-between">
        <JoszakiButton @click="closeModal">
          {{ $t("common.cancel") }}
        </JoszakiButton>
        <JoszakiButton
          type="error"
          icon-left="exclamation-circle"
          :disabled="answerReportBody.length < 5"
          @click="reportAnswer"
        >
          {{ $t("questionPage.reportAnswerModal.submitButton") }}
        </JoszakiButton>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import {
  MODAL_REPORT_ANSWER,
  useQuestionStore,
} from "~/stores/question/question";

export default {
  name: "ReportAnswerModal",
  setup() {
    return {
      questionStore: useQuestionStore(),
    };
  },
  data: () => {
    return {
      answerReportBody: "",
      isSaving: false,
    };
  },
  computed: {
    isModalOpen() {
      return this.questionStore.isModalOpen(MODAL_REPORT_ANSWER);
    },
    answer() {
      return this.questionStore.modalInput(MODAL_REPORT_ANSWER)?.answer ?? null;
    },
  },
  watch: {
    isModalOpen(newIsOpen) {
      if (newIsOpen) {
        this.answerReportBody = "";
      }
    },
  },
  methods: {
    async reportAnswer() {
      if (!this.answer) {
        throw new Error("No answer selected for report question modal.");
      }

      try {
        this.isSaving = true;
        await this.questionStore.reportAnswer(
          Number(this.answer.id),
          this.answerReportBody
        );

        this.closeModal();
        this.$joszaki.toast({
          message: this.$t("questionPage.reportAnswerModal.success"),
          position: "is-top",
          type: "success",
        });
      } catch (e) {
        console.error(e);
        this.$joszaki.toast({
          message: this.$t("questionPage.reportAnswerModal.error"),
          position: "is-top",
          type: "danger",
        });
      } finally {
        this.isSaving = false;
      }
    },
    closeModal() {
      this.questionStore.closeModal();
    },
  },
};
</script>
